export default {
      id: "attach-usage",
      viewBox: "0 0 22 21",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#attach",
      toString: function () {
        return this.url;
      }
    }